module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-alert"
  }, [_c('div', {
    staticClass: "open-dialer",
    on: {
      "click": function($event) {
        return _vm.emitOpenCompose()
      }
    }
  }), _c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/email-header.svg")
    }
  }), _c('account-status-info', {
    attrs: {
      "show_alert": _vm.show_alert,
      "account_status": _vm.account_status,
      "nylas_setting": _vm.nylas_setting
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57dec966!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/header_actions/email.vue
// module id = 1126
// module chunks = 1